import FundraiserPageDonatePage from '@/pages/fundraisers/public/FundraiserPageDonatePage.vue'
import FundraiserPagePublicPage from '@/pages/fundraisers/public/FundraiserPagePublicPage.vue'
import FundraiserPageDonationReturnPublicPage from '@/pages/fundraisers/public/donation-return/FundraiserPageDonationReturnPublicPage.vue'
import FundraiserPageRedirectOldPage from '@/pages/fundraisers/public/FundraiserPageRedirectOldPage.vue'

export default [
  {
    path: "/fundraiser-support/:fundraiserPageId/:slug/widget",
    name: 'FundraiserPagePublicWidgetPage',
    component: FundraiserPagePublicPage,
    props: route => ({ fundraiserPageId: parseInt(route.params.fundraiserPageId), slug: route.params.slug, layout: 'fundraiser-page-layout-widget' }),
  },
  {
    path: "/fundraiser-support/:fundraiserPageId/:slug/:section?",
    name: 'FundraiserPagePublicPage',
    component: FundraiserPagePublicPage,
    props: route => ({ fundraiserPageId: parseInt(route.params.fundraiserPageId), slug: route.params.slug, section: route.params.section }),
  },
  {
    path: "/fundraiser-support/:fundraiserPageId/donate",
    name: 'FundraiserPageDonatePage',
    component: FundraiserPageDonatePage,
    props: route => ({ fundraiserPageId: parseInt(route.params.fundraiserPageId)})
  },
  {
    path: "/fundraiser-support/:fundraiserPageId/donations/:donationId/return",
    name: 'FundraiserPageDonationReturnPublicPage',
    component: FundraiserPageDonationReturnPublicPage,
    props: route => ({ fundraiserPageId: parseInt(route.params.fundraiserPageId), donationId: parseInt(route.params.donationId) })
  },

  {
    path: "/fundraiser-page-redirect/:oldId",
    name: 'FundraiserPageRedirectOld',
    component: FundraiserPageRedirectOldPage,
    props: route => ({ oldId: parseInt(route.params.oldId) })
  }

]
